
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import CarEdit from '@/components/Car/CarEdit.vue';

@Component({
  components: {
    CarEdit,
  },
})
export default class CarEditButton extends Vue {
  @Prop(String) public id!: string;
  public showDialog = false;

  @Emit()
  public carUpdated() {
    this.showDialog = false;
  }
}
